import React, { DetailedHTMLProps, FunctionComponent } from 'react';

import './Radio.scss';

export const Radio: FunctionComponent<DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
>> = (props) => {
    return (
        <label className={['shopping-planner-radio', props.className ?? ''].join(' ')} key={props.key}>
            <input type="radio" {...props} className="" key="" children={null} />
            <div
                className={[
                    'shopping-planner-radio__box',
                    props.checked ? 'shopping-planner-radio__box--checked' : '',
                ].join(' ')}
            >
                {props.checked ? <span className="shopping-planner-radio__circle" /> : null}
            </div>
            {props.children}
        </label>
    );
};
